import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Topheader } from './../../components/Topheader';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import LoadingOverlay from 'react-loading-overlay';
import { Textfield } from './../../components/Textfield';
import { addProduct } from '../../actions/ProductAction';
import { Buttons } from './../../components/Buttons';
import { SuccessMessage } from './../../components/Message/SuccessMessage';
import { ErrorMessage } from './../../components/Message/ErrorMessage';
import validator from '../../helpers/checkValidations';
import { useTheme } from '@material-ui/core/styles';
import config from './../../constants/config';
import classesCus from './Products.module.scss';
import { DialogBox } from './../../components/DialogBox/DialogBox';
import TextfieldLable from './TextfieldLable';
import CloseIcon from '@material-ui/icons/Close';
import InputAdornment from '@material-ui/core/InputAdornment';
import PropTypes from 'prop-types';
import { initialState, useStyles } from './ProductsInitialState';
import { changeCustomerFieldsHandler, handleRemove, changeHandler, setUser, handleLabels } from './CommonFunctions';
class AddProducts extends Component {
  constructor(props) {
    super(props);
    this.state = initialState;
  }

  componentDidMount() {
    this.setState({ isLoading: true });
    const user = setUser(this.setState);
    this.setState(user);
  }

  handleChangeAdd(event, _t) {
    const { id, value, misMatchError, error, validationMarkup } = changeHandler(event);
    if (!validationMarkup) {
      return false;
    }
    this.setState({
      [id]: value,
      error,
      misMatchError,
      isSubmit: false,
      successMessages: false,
    });
  }

  handleChangeCustom(event, _t, i) {
    const { values, error } = changeCustomerFieldsHandler(this.state, event, i);
    this.setState({ customFields: values, error });
  }

  handleRemove(i) {
    const values = handleRemove(this.state, i);
    this.setState({ customFields: values });
  }

  handleSubmit(_e, _t) {
    let misMatchError = [];
    let logoError = [];
    let successMessages = false;
    let state = this.state;
    let error = {};
    let errorFlag = false;
    this.setState({ isSubmit: true });

    if (state.notes === '') {
      delete state.notes;
    }
    //check cutom fields values
    const values = [...this.state.customFields];
    values.forEach((key, _val) => {
      return key['value'] == null || (typeof key['value'] === 'string' && key['value'].trim() === '')
        ? ((error[key.label + 'Error'] = true), (errorFlag = true))
        : (error[key.label + 'Error'] = false);
    });
    Object.keys(this.state).forEach((key) => {
      if (
        validator(key, this.state[key]) ||
        this.state[key] === '' ||
        (typeof this.state[key] === 'string' && this.state[key].trim() === '')
      ) {
        error[key + 'Error'] = true;
        errorFlag = true;
      } else {
        error[key + 'Error'] = false;
      }
    });

    if (errorFlag) {
      console.log(error, 'error');
      this.setState({ misMatchError, logoError, error, successMessages });
      return false;
    } else {
      this.setState({ isLoading: true });
      console.log('this.state', this.state);
      this.props.addProduct(state).then((result) => {
        if (result !== undefined && result.type === 'PRODUCT_SUCCESS') {
          this.setState({ ...initialState, isLoading: false, successMessages: true }, () => {
            setTimeout(function () {
              window.location.href = config.APPURL + 'Products';
            }, 2000);
          });
        }
        if (result !== undefined && result.type === 'PRODUCT_ERROR') {
          this.setState({
            misMatchError: this.props.info.productInfo.data.message,
            isLoading: false,
            successMessages,
          });
        }
      });
    }
  }

  handleLabels = (data) => {
    const values = handleLabels(data, this.state);
    this.setState({ customFields: values });
  };

  render() {
    const { classes, t } = this.props;
    return (
      <div className="rightPanel">
        <Topheader />
        <div className="contentPart">
          <LoadingOverlay active={this.state.isLoading} spinner text="Loading your content...">
            <Container component="main" maxWidth="xl">
              {this.state.misMatchError.length > 0 ? <ErrorMessage errors={[this.state.misMatchError]} /> : ''}
              {this.state.successMessages ? (
                <SuccessMessage successes={[this.props.info.productInfo.data.message]} />
              ) : (
                ''
              )}
              <h3>Add Product</h3>
              <form className={classes.form} noValidate ref={this.myRef}>
                <DialogBox
                  open={this.state.isOpen}
                  handleClose={() => this.setState({ isOpen: false })}
                  message={
                    <TextfieldLable
                      handleClose={() => this.setState({ isOpen: false })}
                      handleLabels={this.handleLabels}
                    />
                  }
                />
                <Grid container item xs={12} spacing={1}>
                  <Grid container item sm={6} xs={12}>
                    <div data-cy="product-name">
                      <Textfield
                        required={true}
                        error={this.state.error.nameError}
                        id="name"
                        type="text"
                        labels={t('Name')}
                        value={this.state.name}
                        width={true}
                        onChange={(e) => this.handleChangeAdd(e, t)}
                        focus={true}
                      />
                    </div>
                  </Grid>

                  <Grid container item sm={6} xs={12}>
                    <div data-cy="product-amount">
                      <Textfield
                        required={true}
                        error={this.state.error.amountError}
                        InputProps={{
                          startAdornment: <InputAdornment position="start">$</InputAdornment>,
                        }}
                        id="amount"
                        type="text"
                        labels={t('Amount')}
                        value={this.state.amount}
                        width={true}
                        focus={true}
                        onChange={(e) => this.handleChangeAdd(e, t)}
                        onFocus={({ target }) => {
                          this.setState({
                            amount: String(target.value),
                          });
                        }}
                        onBlur={({ target }) => {
                          this.setState({
                            amount: Number(target.value).toFixed(2),
                            error: { ...this.state.error, amountError: false },
                          });
                        }}
                        placeholder="0.00"
                      />
                    </div>
                  </Grid>
                  <Grid container item sm={6} xs={12}>
                    <div data-cy="product-desc">
                      <Textfield
                        required={true}
                        error={this.state.error.descriptionError}
                        id="description"
                        type="text"
                        labels={t('Description')}
                        value={this.state.description}
                        width={true}
                        multiline={true}
                        rowsMax={2}
                        rows={2}
                        onChange={(e) => this.handleChangeAdd(e, t)}
                      />
                    </div>
                  </Grid>
                  <Grid container item sm={6} xs={12}>
                    <Textfield
                      error={this.state.error.notesError}
                      id="notes"
                      type="text"
                      labels={t('Notes')}
                      value={this.state.notes}
                      width={true}
                      multiline={true}
                      rowsMax={2}
                      rows={2}
                      onChange={(e) => this.handleChangeAdd(e, t)}
                      focus={true}
                    />
                  </Grid>
                  <Grid container item sm={12} xs={12} justify="flex-end">
                    <Buttons
                      className={classesCus.ml_2}
                      variant="contained"
                      color="secondary"
                      text={t('AddMore')}
                      onClick={(_e) => this.setState({ isOpen: true })}
                    />
                  </Grid>
                  {this.state.customFields.map((field, idx) => {
                    return (
                      <Grid item sm={6} xs={6} key={idx}>
                        <div key={`${field}-${idx}`}>
                          <CloseIcon onClick={() => this.handleRemove(idx)} />
                          <Textfield
                            required={true}
                            error={this.state.error[field.label + 'Error']}
                            id={field.label}
                            type="text"
                            labels={field.label}
                            value={field.value || ''}
                            width={true}
                            onChange={(e) => this.handleChangeCustom(e, t, idx)}
                            focus={true}
                          />
                        </div>
                      </Grid>
                    );
                  })}
                </Grid>
                <Grid item xs={12} sm={12} className="mt-2">
                  <Buttons
                    id="signUp"
                    type="button"
                    variant="contained"
                    color="primary"
                    onClick={(e) => this.handleSubmit(e, t)}
                    text={t('Save')}
                  />
                  <Buttons
                    className={classesCus.ml_2}
                    variant="contained"
                    color="secondary"
                    text={t('Back')}
                    onClick={this.props.history.goBack}
                  />
                </Grid>
              </form>
            </Container>
          </LoadingOverlay>
        </div>
      </div>
    );
  }
}

const ApplyingStyles = (props) => {
  const classes = useStyles();
  const theme = useTheme();
  return <AddProducts theme={theme} classes={classes} {...props} />;
};

function mapStateToProps(state) {
  return {
    info: state.ProductReducer,
  };
}

export default connect(mapStateToProps, { addProduct })(withTranslation()(withRouter(ApplyingStyles)));

AddProducts.propTypes = {
  addProduct: PropTypes.func,
  info: PropTypes.any,
  classes: PropTypes.any,
  t: PropTypes.any,
  history: PropTypes.any,
};
